import React from 'react'

import PropTypes from 'prop-types'
import { Box, IconButton, Typography } from '@material-ui/core'
import { Trash as TrashIcon } from 'react-feather'
import { isEmpty } from 'lodash'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import useStyles from './styles'

const StagedPlanActionsTable = ({
  stagedPlanActions,
  setStagedPlanActions,
  saving,
}) => {
  const classes = useStyles()

  const handleRemove = (index) =>
    setStagedPlanActions((current) =>
      current.filter((_, itemIndex) => itemIndex !== index),
    )

  return (
    <Box className={classes.tableContainer}>
      <Table size="small" noWrap stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell align="left" width="80%">
              Plano de Ação Adicionadas
            </TableCell>
            <TableCell align="right" width="20%">
              Ações
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!isEmpty(stagedPlanActions) ? (
            stagedPlanActions.map((item, index) => (
              <TableRow key={index}>
                <TableCell align="left">
                  <Typography variant="body2">{item.name}</Typography>
                </TableCell>
                <TableCell align="right">
                  <IconButton
                    onClick={() => handleRemove(index)}
                    disabled={saving}
                  >
                    <TrashIcon size={20} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={2} align="left" className={classes.empty}>
                <Typography variant="caption">
                  Nenhum plano de ação adicionado.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Box>
  )
}

StagedPlanActionsTable.propTypes = {
  stagedPlanActions: PropTypes.array,
  setStagedPlanActions: PropTypes.func.isRequired,
  saving: PropTypes.bool,
}

export default StagedPlanActionsTable
